import React from "react";

const Document2Icon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.464"
      height="20.634"
      viewBox="0 0 18.464 22.634"
    >
      <path
        id="Subtraction_5"
        dataName="Subtraction 5"
        d="M18.464,22.634H0V0H11.869V6.657h6.594V22.633ZM3.3,17.64V19.4H14.469V17.64Zm0-4.4V15H14.469V13.243Zm0-4.4V10.6H14.469V8.845Zm14.968-3.52H13.188V.2l5.077,5.125Z"
        fill="#fff"
      />
    </svg>
  );
};

export default Document2Icon;



// WEBPACK FOOTER //
// ./src/assets/Document2Icon.jsx